import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import translationsEN from '../../public/assets/i18n/en.json';
import translationsNL from '../../public/assets/i18n/nl.json';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly translate = inject(TranslateService);

  constructor() {
    const defaultLanguage = 'en';

    this.translate.setTranslation('en', translationsEN);
    this.translate.setTranslation('nl', translationsNL);

    const language = this.translate.getBrowserLang() ?? defaultLanguage;
    this.translate.setDefaultLang(defaultLanguage);
    this.translate.use(language);
  }
}
